import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import Link from '@cotyorg/ccx-atoms/Link';
import R from 'ramda';
import SectionHeader from '../../../atoms/SectionHeader';

export const StudySection = ({ sectionHeading, link, button }) => (
  <div className="study article-section article-section--padding-bottom">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Heading level={2}>{R.prop('heading', sectionHeading)}</Heading>
          </SectionHeader>
          <Paragraph>{R.prop('introduction', sectionHeading)}</Paragraph>
          <div className="flex-container align-center">
            <Link
              extraClass="cyberbullying__cta-block"
              link={R.prop('href', link)}
              target="_blank"
            >
              {R.prop('label', button)}
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);

StudySection.propTypes = {
  sectionHeading: PropTypes.instanceOf(PropTypes.object),
  link: PropTypes.instanceOf(PropTypes.object),
  button: PropTypes.instanceOf(PropTypes.object),
};
